import LibraryItemSkeleton from '@/components/Library/LibraryItemSkeleton';
import styled from '@emotion/styled';

const StyledSkeleton = styled(LibraryItemSkeleton)<{ maxWidth: number }>`
    width: 100%;
    max-width: ${({ maxWidth }) => `${maxWidth}px`};
    margin-top: 0;
`;

const GAP = 24;
const ONE_COLUMN_BREAKPOINT = 928;

const Container = styled.div<{ containerMinWidth: number }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 0 2% 1rem 4%;
    gap: ${GAP}px;

    @media only screen and (min-width: ${ONE_COLUMN_BREAKPOINT}px) {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(${({ containerMinWidth }) => `${containerMinWidth}px`}, 1fr));
        grid-gap: ${GAP}px;
    }
`;

interface LoadingSkeletonsProps {
    count: number;
    skeletonMaxWidth: number;
    containerMinWidth: number;
}
export const LoadingSkeletons = ({ count, skeletonMaxWidth, containerMinWidth }: LoadingSkeletonsProps) => (
    <Container containerMinWidth={containerMinWidth}>
        {new Array(count).fill('').map((_, i) => (
            <StyledSkeleton key={i} maxWidth={skeletonMaxWidth} />
        ))}
    </Container>
);
